module.exports = __webpack_public_path__ + "img/banner-bg(alt_1).871bad9d.jpg";